import React, {Component} from 'react';
import {Breadcrumb, BreadcrumbItem, Row} from "mdbreact";
import {Link} from "react-router-dom";
import {API_URL} from "../../config/Config";
import axios from "axios/index";
import Merchant from "../../components/merchants/Merchant";
import axiosRetry from 'axios-retry';
import PageLoader from "../../components/loader/PageLoader";
axiosRetry(axios, { retries: 3 });


export default class MerchantList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            merchants:[],
            loading:false,
        };


    }
    async componentDidMount(){
        await this.getMerchantList();
    }
    async getMerchantList() {
        try {
            let response = await axios.get(`${API_URL}merchant`);
            let merchants = await response.data.data;
            console.log(merchants)
            this.setState({merchants});
        }catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                let statusText = await apiError.statusText;
                console.log(statusText);
            }
        }
        this.setState({loading: true});
    }


    render() {
        return (
            <div >
                <div className="jumbotron text-center rtl">

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5">
                        <div className="p-2 text-right rtl">
                            <h1 className="pag-title">مراکز طرف قرارداد</h1>
                        </div>
                        <div className="ml-auto p-2">
                            <Breadcrumb className="">
                                <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                                {/*<BreadcrumbItem><a href="#">محصولات</a></BreadcrumbItem>*/}
                                <BreadcrumbItem active>مراکز طرف قرارداد</BreadcrumbItem>
                            </Breadcrumb>

                        </div>
                    </div>
                </div>

                <div className="container rtl">
                    {!this.state.loading? <PageLoader type="spinningBubbles" color="#f6581d" />:
                    <Row>
                        {this.state.merchants.map( merchant =>
                            <Merchant key={merchant.id} merchantObj={merchant}/>
                        )}
                    </Row>}
                </div>

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/merchants/MerchantList.js